/**
 * Which page numbers to draw, given where you are and how many there are.
 *
 * Always shows the first and last page plus a window around the current one,
 * with '…' standing in for the gaps, so the control stays a predictable width
 * whether there are three pages or three hundred.
 */
export const pageRange = (page, pageCount, window = 1) => {
  if (pageCount <= 1) return [1];

  const pages = new Set([1, pageCount]);
  for (let p = page - window; p <= page + window; p += 1) {
    if (p > 1 && p < pageCount) pages.add(p);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const withGaps = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) withGaps.push('…');
    withGaps.push(p);
  });
  return withGaps;
};

export default pageRange;
